import { useMemo } from "react";

import { useUser } from "@/context/user-context";

// Returns the active workspace object, null if loading, or undefined if not in a workspace
const useActiveWorkspace = () => {
  const userContext = useUser();

  return useMemo(() => {
    const activeWorkspaceId = userContext?.activeWorkspaceId;
    const { workspaces } = userContext;
    if (!activeWorkspaceId || !workspaces.length) {
      return null;
    }
    return workspaces.find(({ id }) => id === activeWorkspaceId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userContext?.activeWorkspaceId, userContext.workspaces]);
};

export default useActiveWorkspace;
